import type { Component } from 'vue';
import vuetify from '@/main';
import {
  knownReportFilterPanel,
  resolveReportFilterPanel,
} from './reportFilterPanelSync';

type FeatureUserService = Parameters<typeof resolveReportFilterPanel>[0];

let instance = 0;

/**
 * `vuetify()` fixes one host id per directive definition, so two instances on a page —
 * trust-detail prints two tile blocks — would mount into the same element.
 */
export function mountReportVue(
  component: Component,
  $scope: { $on: (event: string, fn: () => void) => void },
  element: { html: (markup: string) => void },
  $injector: {
    invoke: (fn: unknown, self: unknown, locals: object) => unknown;
  },
) {
  instance += 1;
  const { template, controller } = vuetify(
    component,
    `ll-report-vue-${instance}`,
  );
  element.html(template);
  $injector.invoke(controller, null, { $scope });
}

/**
 * Runs `link` with whether `reportFilterPanel` is on. Synchronous once known, so legacy
 * directives attach in the same tick as before — `filterTiles` would otherwise miss the
 * first filter broadcast. The answer is shared with `generic.ctrl` (see
 * `resolveReportFilterPanel`) and re-checked against `/me` on every link.
 */
export function withReportFilterPanelFeature(
  userService: FeatureUserService,
  envFeatures: Record<string, boolean> | undefined,
  isAlive: () => boolean,
  link: (enabled: boolean) => void,
) {
  const known = knownReportFilterPanel();
  const resolving = resolveReportFilterPanel(userService, envFeatures);
  if (known !== null) {
    link(known);
    return;
  }
  resolving.then((enabled) => {
    if (isAlive()) link(enabled);
  });
}
